import { styled } from '@mui/material';

export const Content = styled('div')(() => ({
  marginTop: '3rem',
  paddingRight: '1.25rem',
  paddingLeft: '1.25rem',
}));
